module.exports = __webpack_public_path__ + "static/media/code.a6bc26c1.jpg";